import { Component } from "react"
import PropTypes from "prop-types"

import DropdownServiceSelector from "shared/components/dropdown_service_selector"

import { loadService } from "./gql"

export default class ServiceSelector extends Component {
  state = {
    errorLoadingService: false,
  }

  onServiceSelect = s => {
    loadService(s)
      .then(service => {
        this.setState({ selectedService: service })
        this.props.onServiceSelect(service)
      })
      .catch(() => {
        this.setState({ errorLoadingService: true })
      })
  }

  render() {
    return (
      <>
        <div className="partners-service-composer-selectors">
          <DropdownServiceSelector
            services={this.props.services}
            onSelect={this.onServiceSelect}
            placeholderCopy="Search services"
            selectedService={this.state.selectedService}
          />
        </div>

        {this.state.errorLoadingService && (
          <div style={{ color: "red" }}>
            Error loading service. Please try again later
          </div>
        )}
      </>
    )
  }
}

ServiceSelector.propTypes = {
  services: PropTypes.arrayOf(
    PropTypes.shape({
      module_name: PropTypes.string.isRequired,
      name: PropTypes.string.isRequired,
      icon: PropTypes.string,
    })
  ).isRequired,

  selectedService: PropTypes.shape({
    id: PropTypes.string,
    module_name: PropTypes.string,
  }),

  onServiceSelect: PropTypes.func.isRequired,
  last: PropTypes.bool,
}
